import Card from 'app/frontend/base/components/Card'
import { Button } from '@/components/ui/button'
import RichTextContent from 'app/frontend/base/components/RichTextContent'
import { useTeamEventUpdateContext } from '../context/TeamEventUpdateContext'
import NotesEditor, {
  hasNotesContent,
} from 'app/frontend/base/components/NotesEditor'

export { hasNotesContent }

type Props = {
  event: wowaudit.Event
  canEdit: boolean
  isEditing: boolean
  onStartEdit: () => void
  onStopEdit: () => void
}

const EventNotes = ({
  event,
  canEdit,
  isEditing,
  onStartEdit,
  onStopEdit,
}: Props) => {
  const { updateEvent } = useTeamEventUpdateContext()

  if (isEditing) {
    return (
      <div className='mt-4 flex flex-col gap-1'>
        <span className='text-sm text-muted-foreground'>Message</span>
        <NotesEditor
          initialValue={event.notes ?? ''}
          onSave={async (notes) => {
            await updateEvent({ notes })
            onStopEdit()
          }}
          onCancel={onStopEdit}
        />
      </div>
    )
  }

  if (!hasNotesContent(event.notes)) return null

  return (
    <div className='mt-4 flex flex-col gap-1'>
      <div className='flex items-center justify-between'>
        <span className='text-sm text-muted-foreground'>Message</span>
        {canEdit ? (
          <Button variant='outline' size='xs' onClick={onStartEdit}>
            Edit
          </Button>
        ) : null}
      </div>
      <Card>
        <RichTextContent content={event.notes ?? ''} />
      </Card>
    </div>
  )
}

export default EventNotes
